import { render, staticRenderFns } from "./OrderInfoView.vue?vue&type=template&id=d9d4e5c4&scoped=true&"
import script from "./OrderInfoView.vue?vue&type=script&lang=js&"
export * from "./OrderInfoView.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoView.vue?vue&type=style&index=0&id=d9d4e5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d4e5c4",
  null
  
)

export default component.exports